import "../style.scss";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import logo from "../img/logo.png";
import Header from "components/Header";
import Footer_Under from "components/Footer_Under";
import Header_Under from "components/Header_Under";

export default function Impressum() {
  // useEffect(() => {
  //   //mobile nav
  //   const openIcon = document.querySelector(".fa-bars");
  //   const closeIcon = document.querySelector(".close-nav");
  //   const mobileBG = document.querySelector(".mobile-bg");
  //   const mobileNav = document.querySelector(".mobile-nav");
  //   const navItem = document.querySelector(".nav-item");

  //   openIcon.addEventListener("click", () => {
  //     mobileBG.classList.toggle("display-none");
  //     mobileNav.classList.remove("slide-out");
  //     mobileNav.classList.toggle("slide-in");
  //     openIcon.classList.toggle("display-none");
  //   });

  //   closeIcon.addEventListener("click", () => {
  //     setTimeout(() => {
  //       mobileBG.classList.toggle("display-none");
  //       openIcon.classList.toggle("display-none");
  //     }, 500);
  //     mobileNav.classList.toggle("slide-in");
  //     mobileNav.classList.toggle("slide-out");
  //   });

  //   navItem.addEventListener("click", () => {
  //     mobileBG.classList.toggle("display-none");
  //     mobileNav.classList.remove("slide-out");
  //     mobileNav.classList.toggle("slide-in");
  //     openIcon.classList.toggle("display-none");
  //   });
  // });

  return (
    <html lang="de">
      <body style={{ backgroundColor: "#191919" }}>
        {/* Mobile Nav */}
        <div className="mobile-bg display-none">
          <ul className="mobile-nav">
            <li>
              <a href="/" className="nav-item">
                Zurück
              </a>
            </li>
          </ul>
          <div
            className="close-nav"
            style={{
              backgroundColor: "transparent",
              width: "100%",
              height: "100%",
            }}
          ></div>
        </div>
        {/* Nav */}
        <Header_Under></Header_Under>

        <div style={{ height: 130 }}></div>

        {/* <header>
          <nav className="container">
            <a>
              <img src={logo} alt="" />
            </a>

            <i
              style={{ paddingRight: "20px", color: "#a4ffee" }}
              className="fas fa-bars"
            >
              <FontAwesomeIcon
                style={{ color: "#a4ffee", cursor: "pointer" }}
                icon={icon({ name: "bars", style: "solid" })}
              />
            </i>
            <ul>
              <li>
                <a href="/">Zurück</a>
              </li>
            </ul>
          </nav>
        </header> */}

        <div
          className="container"
          style={{ padding: "100px 50px", paddingBottom: "50px" }}
        >
          <h2
            style={{
              color: "#a4ffee",
              textAlign: "left",
              paddingBottom: "20px",
            }}
          >
            Datenschutzerklärung
          </h2>
          <p style={{ color: "#fff", whiteSpace: "pre-wrap" }}>
            {`Einleitung

Wir nehmen den Schutz der Daten der Nutzer unserer Website und/oder unseres Mobile-App (die „Website“ bzw. der „Mobile-App“) sehr ernst und verpflichten uns, die Informationen, die Nutzer uns in Verbindung mit der Nutzung unserer Website und/oder unseres Mobile-App (zusammen: „digitale Assets“) zur Verfügung stellen, zu schützen. Des Weiteren verpflichten wir uns, Ihre Daten gemäß anwendbarem Recht zu schützen und zu verwenden.

Diese Datenschutzrichtlinie erläutert unsere Praktiken in Bezug auf die Erfassung, Verwendung und Offenlegung Ihrer Daten durch die Nutzung unserer digitalen Assets (die „Dienste“), wenn Sie über Ihre Geräte auf die Dienste zugreifen.

Lesen Sie die Datenschutzrichtlinie bitte sorgfältig durch und stellen Sie sicher, dass Sie unsere Praktiken in Bezug auf Ihre Daten vollumfänglich verstehen, bevor Sie unsere Dienste verwenden. Wenn Sie diese Richtlinie gelesen, vollumfänglich verstanden haben und nicht mit unserer Vorgehensweise einverstanden sind, müssen Sie die Nutzung unserer digitalen Assets und Dienste einstellen. Mit der Nutzung unserer Dienste erkennen Sie die Bedingungen dieser Datenschutzrichtlinie an. Die weitere Nutzung der Dienste stellt Ihre Zustimmung zu dieser Datenschutzrichtlinie und allen Änderungen daran dar.

In dieser Datenschutzrichtlinie erfahren Sie:

Wie wir Daten sammeln

Welche Daten wir erfassen

Warum wir diese Daten erfassen

An wen wir die Daten weitergeben

Wo die Daten gespeichert werden

Wie lange die Daten vorgehalten werden

Wie wir die Daten schützen

Wie wir mit Minderjährigen umgehen

Aktualisierungen oder Änderungen der Datenschutzrichtlinie



Welche Daten erfassen wir?

Nachstehend erhalten Sie einen Überblick über die Daten, die wir erfassen können:



Nicht identifizierte und nicht identifizierbare Informationen, die Sie während des Registrierungsprozesses bereitstellen oder die über die Nutzung unserer Dienste gesammelt werden („nicht personenbezogene Daten“). Nicht personenbezogene Daten lassen keine Rückschlüsse darauf zu, von wem sie erfasst wurden. Nicht personenbezogene Daten, die wir erfassen, bestehen hauptsächlich aus technischen und zusammengefassten Nutzungsinformationen.

Individuell identifizierbare Informationen, d. h. all jene, über die man Sie identifizieren kann oder mit vertretbarem Aufwand identifizieren könnte („personenbezogene Daten“). Zu den personenbezogenen Daten, die wir über unsere Dienste erfassen, können Informationen gehören, die von Zeit zu Zeit angefordert werden, wie Namen, E-Mail-Adressen, Adressen, Telefonnummern, IP-Adressen und mehr. Wenn wir personenbezogene mit nicht personenbezogenen Daten kombinieren, werden diese, solange sie in Kombination vorliegen, von uns als personenbezogene Daten behandelt.



Wie sammeln wir Daten?

Nachstehend sind die wichtigsten Methoden aufgeführt, die wir zur Sammlung von Daten verwenden:



Wir erfassen Daten bei der Nutzung unserer Dienste. Wenn Sie also unsere digitalen Assets besuchen und Dienste nutzen, können wir die Nutzung, Sitzungen und die dazugehörigen Informationen sammeln, erfassen und speichern.

Wir erfassen Daten, die Sie uns selbst zur Verfügung stellen, beispielsweise, wenn Sie über einen Kommunikationskanal direkt mit uns Kontakt aufnehmen (z. B. eine E-Mail mit einem Kommentar oder Feedback).

Wir können, wie unten beschrieben, Daten aus Drittquellen erfassen.

Wir erfassen Daten, die Sie uns zur Verfügung stellen, wenn Sie sich über einen Drittanbieter wie Facebook oder Google bei unseren Diensten anmelden.



Warum erfassen wir diese Daten?

Wir können Ihre Daten für folgende Zwecke verwenden:



um unsere Dienste zur Verfügung zu stellen und zu betreiben;

um unsere Dienste zu entwickeln, anzupassen und zu verbessern;

um auf Ihr Feedback, Ihre Anfragen und Wünsche zu reagieren und Hilfe anzubieten;

um Anforderungs- und Nutzungsmuster zu analysieren;

für sonstige interne, statistische und Recherchezwecke;

um unsere Möglichkeiten zur Datensicherheit und Betrugsprävention verbessern zu können;

um Verstöße zu untersuchen und unsere Bedingungen und Richtlinien durchzusetzen sowie um dem anwendbaren Recht, den Vorschriften bzw. behördlichen Anordnungen zu entsprechen;

um Ihnen Aktualisierungen, Nachrichten, Werbematerial und sonstige Informationen im Zusammenhang mit unseren Diensten zu übermitteln. Bei Werbe-E-Mails können Sie selbst entscheiden, ob Sie diese weiterhin erhalten möchten. Wenn nicht, klicken Sie einfach auf den Abmeldelink in diesen E-Mails.



An wen geben wir diese Daten weiter?

​

Wir können Ihre Daten an unsere Dienstleister weitergeben, um unsere Dienste zu betreiben (z. B. Speicherung von Daten über Hosting-Dienste Dritter, Bereitstellung technischer Unterstützung usw.).



Wir können Ihre Daten auch unter folgenden Umständen offenlegen: um rechtswidrige Aktivitäten oder sonstiges Fehlverhalten zu untersuchen, aufzudecken, zu verhindern oder dagegen vorzugehen; (ii) um unsere Rechte auf Verteidigung zu begründen oder auszuüben; (iii) um unsere Rechte, unser Eigentum oder unsere persönliche Sicherheit sowie die Sicherheit unserer Nutzer oder der Öffentlichkeit zu schützen; (iv) im Falle eines Kontrollwechsels bei uns oder bei einem unserer verbundenen Unternehmen (im Wege einer Verschmelzung, des Erwerbs oder Kaufs (im Wesentlichen) aller Vermögenswerte u. a.); (v) um Ihre Daten mittels befugter Drittanbieter zu erfassen, vorzuhalten und/oder zu verwalten (z. B. Cloud-Service-Anbieter), soweit dies für geschäftliche Zwecke angemessen ist; (vi) um mit Drittanbietern gemeinsam an der Verbesserung Ihres Nutzererlebnisses zu arbeiten. Zur Vermeidung von Missverständnissen möchten wir darauf hinweisen, dass wir nicht personenbezogene Daten nach eigenem Ermessen an Dritte übermitteln bzw. weitergeben oder anderweitig verwenden können.

Kategorie: Nutzer hat einen Blog oder ein Forum

Bitte beachten Sie, dass unsere Dienste soziale Interaktionen (z. B. Inhalte, Informationen und Kommentare öffentlich posten und mit anderen Nutzern chatten) ermöglichen. Wir weisen Sie darauf hin, dass alle Inhalte oder Daten, die Sie in diesen Bereichen zur Verfügung stellen, von anderen Personen gelesen, erfasst und verwendet werden können. Wir raten davon ab, Informationen zu posten oder mit anderen zu teilen, die Sie nicht öffentlich machen wollen. Wenn Sie Inhalte auf unseren digitalen Assets hochladen oder anderweitig im Rahmen der Nutzung eines Dienstes zur Verfügung stellen, erfolgt dies auf eigenes Risiko. Wir können nicht die Aktionen anderer Nutzer oder Mitglieder der Öffentlichkeit mit Zugriff auf Ihre Daten oder Inhalte kontrollieren. Sie nehmen zur Kenntnis und bestätigen hiermit, dass Kopien Ihrer Daten selbst nach deren Löschung auf zwischengespeicherten und archivierten Seiten oder nach der Erstellung einer Kopie/Speicherung Ihrer Inhalte durch Dritte abrufbar bleiben können.

Cookies und ähnliche Technologien

Wenn Sie unsere Dienste besuchen oder darauf zugreifen, autorisieren wir Dritte dazu, Webbeacons, Cookies, Pixel Tags, Skripte sowie andere Technologien und Analysedienste („Tracking-Technologien“) einzusetzen. Diese Tracking-Technologien können es Dritten ermöglichen, Ihre Daten automatisch zu erfassen, um das Navigationserlebnis auf unseren digitalen Assets zu verbessern, deren Performance zu optimieren und ein maßgeschneidertes Nutzererlebnis zu gewährleisten, sowie zu Zwecken der Sicherheit und der Betrugsprävention.



Um mehr darüber zu erfahren, lesen Sie bitte unsere Cookie-Richtlinie.

Kategorie: Der Nutzer ist NICHT mit einem Werbedienst verbunden

Ohne Ihre Zustimmung werden wir Ihre E-Mail-Adresse oder andere personenbezogenen Daten nicht an Werbeunternehmen oder Werbenetzwerke weitergeben.

Kategorie: Der Nutzer ist mit einem Werbedienst, einem Campaign Manager oder mit Facebook Ads verbunden

Wir können über unsere Dienste und unsere digitalen Assets (einschließlich Websites und Anwendungen, die unsere Dienste einsetzen) Werbung bereitstellen, die auch auf Sie zugeschnitten sein kann, z. B. Anzeigen, die auf Ihrem jüngsten Surfverhalten auf Websites, Geräten oder Browsern basieren.



Um diese Werbeanzeigen für Sie bereitzustellen, können wir Cookies und/oder JavaScript und/oder Webbeacons (einschließlich durchsichtiger GIFs) und/oder HTML5 Local Storage und/oder andere Technologien einsetzen. Wir können auch Dritte einsetzen, wie z. B. Netzwerkinserenten (d. h. Dritte, die Werbeanzeigen auf der Grundlage Ihrer Website-Besuche einblenden), um gezielte Anzeigen zu schalten. Externe Anbieter von Werbenetzwerken, Werbetreibende, Sponsoren und/oder Dienste zur Messung des Website-Traffics können ebenfalls Cookies und/oder JavaScript und/oder Webbeacons (einschließlich durchsichtiger GIFs) und/oder Flash-Cookies und/oder andere Technologien verwenden, um die Wirksamkeit ihrer Anzeigen zu messen und Werbeinhalte für Sie anzupassen. Diese Drittanbieter-Cookies und andere Technologien unterliegen der spezifischen Datenschutzrichtlinie des jeweiligen Drittanbieters und nicht dieser hier.

Wo speichern wir die Daten?

​

Nicht personenbezogene Daten



Bitte beachten Sie, dass unsere Unternehmen sowie unsere vertrauenswürdigen Partner und Dienstanbieter auf der ganzen Welt ansässig sind. Zu den in dieser Datenschutzrichtlinie erläuterten Zwecke speichern und verarbeiten wir alle nicht personenbezogenen Daten, die wir erfassen, in unterschiedlichen Rechtsordnungen.

​

Personenbezogene Daten

Personenbezogene Daten können in den Vereinigten Staaten, in Irland, Südkorea, Taiwan, Israel und soweit für die ordnungsgemäße Bereitstellung unserer Dienste und/oder gesetzlich vorgeschrieben (wie nachstehend weiter erläutert) in anderen Rechtsordnungen gepflegt, verarbeitet und gespeichert werden.

Wie lange werden die Daten vorgehalten?

​

Bitte beachten Sie, dass wir die erfassten Daten so lange aufbewahren, wie es für die Bereitstellung unserer Dienste, zur Einhaltung unserer gesetzlichen und vertraglichen Verpflichtungen gegenüber Ihnen, zur Beilegung von Streitigkeiten und zur Durchsetzung unserer Vereinbarungen erforderlich ist.

Wir können unrichtige oder unvollständige Daten jederzeit nach eigenem Ermessen berichtigen, ergänzen oder löschen.



Wie schützen wir die Daten?

​

Der Hosting-Dienst für unserer digitalen Assets stellt uns die Online-Plattform zu Verfügung, über die wir Ihnen unsere Dienste anbieten können. Ihre Daten können über die Datenspeicherung, Datenbanken und allgemeine Anwendungen unseres Hosting-Anbieters gespeichert werden. Er speichert Ihre Daten auf sicheren Servern hinter einer Firewall und er bietet sicheren HTTPS-Zugriff auf die meisten Bereiche seiner Dienste.



Alle von uns und unserem Hosting-Anbieter für unsere digitalen Assets angebotenen Zahlungsmöglichkeiten halten die Vorschriften des PCI-DSS (Datensicherheitsstandard der Kreditkartenindustrie) des PCI Security Standards Council (Rat für Sicherheitsstandards der Kreditkartenindustrie) ein. Dabei handelt es sich um die Zusammenarbeit von Marken wie Visa, MasterCard, American Express und Discover. PCI-DSS-Anforderungen helfen, den sicheren Umgang mit Kreditkartendaten (u. a. physische, elektronische und verfahrenstechnische Maßnahmen) durch unseren Shop und die Dienstanbieter zu gewährleisten.

​

Ungeachtet der von uns und unserem Hosting-Anbieter ergriffenen Maßnahmen und Bemühungen können und werden wir keinen absoluten Schutz und keine absolute Sicherheit der Daten garantieren, die Sie hochladen, veröffentlichen oder anderweitig an uns oder andere weitergeben.

​

Aus diesem Grund möchten wir Sie bitten, sichere Passwörter festzulegen und uns oder anderen nach Möglichkeit keine vertraulichen Informationen zu übermitteln, deren Offenlegung Ihnen Ihrer Meinung nach erheblich bzw. nachhaltig schaden könnte. Da E-Mail und Instant Messaging nicht als sichere Kommunikationsformen gelten, bitten wir Sie außerdem, keine vertraulichen Informationen über einen dieser Kommunikationskanäle weiterzugeben.

​

Wie gehen wir mit Minderjährigen um?

​

Die Dienste sind nicht für Nutzer bestimmt, die noch nicht die gesetzliche Volljährigkeit erreicht haben. Wir werden wissentlich keine Daten von Kindern erfassen. Wenn Sie noch nicht volljährig sind, sollten Sie die Dienste nicht herunterladen oder nutzen und uns keine Informationen zur Verfügung stellen.



Wir behalten uns das Recht vor, jederzeit einen Altersnachweis zu verlangen, damit wir überprüfen können, ob Minderjährige unsere Dienste nutzen. Für den Fall, dass wir Kenntnis davon erlangen, dass ein Minderjähriger unsere Dienste nutzt, können wir diesen Nutzern den Zugang zu unseren Diensten untersagen und ihn sperren, und wir können alle bei uns gespeicherten Daten über diesen Nutzer löschen. Sollten Sie Grund zu der Annahme haben, dass ein Minderjähriger Daten an uns weitergegeben hat, nehmen Sie bitte, wie unten erläutert, Kontakt zu uns auf.

​

Wir verwenden Ihre personenbezogenen Daten nur für die in der Datenschutzrichtlinie festgelegten Zwecke und nur, wenn wir davon überzeugt sind, dass:



die Verwendung Ihrer personenbezogenen Daten erforderlich ist, um einen Vertrag zu erfüllen oder zu schließen (z. B. um Ihnen die Dienste selbst oder Kundenbetreuung bzw. technischen Support bereitzustellen);

die Verwendung Ihrer personenbezogenen Daten notwendig ist, um entsprechenden rechtlichen oder behördlichen Verpflichtungen nachzukommen, oder

die Verwendung Ihrer personenbezogenen Daten notwendig ist, um unsere berechtigten geschäftlichen Interessen zu unterstützen (unter der Maßgabe, dass dies jederzeit in einer Weise erfolgt, die verhältnismäßig ist und Ihre Datenschutzrechte respektiert).

Als EU-Ansässiger können Sie:



eine Bestätigung darüber verlangen, ob personenbezogene Daten verarbeitet werden, die Sie betreffen, oder nicht, und Zugriff auf Ihre gespeicherten personenbezogenen Daten sowie auf bestimmte Zusatzinformationen anfordern;

den Erhalt von personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren Format verlangen;

die Berichtigung lhrer personenbezogenen Daten verlangen, die bei uns gespeichert sind;

die Löschung Ihrer personenbezogenen Daten verlangen;

der Verarbeitung Ihrer personenbezogenen Daten durch uns widersprechen;

die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten verlangen, oder

eine Beschwerde bei einer Aufsichtsbehörde einreichen.



Bitte beachten Sie jedoch, dass diese Rechte nicht uneingeschränkt gültig sind und unseren eigenen berechtigten Interessen und regulatorischen Anforderungen unterliegen können. Wenn Sie allgemeine Fragen zu den von uns erfassten personenbezogenen Daten und deren Verwendung haben, wenden Sie sich bitte an uns, wie unten angegeben.

Im Zuge der Bereitstellung der Dienste können wir Daten grenzüberschreitend an verbundene Unternehmen oder andere Dritte und aus Ihrem Land/Ihrer Rechtsordnung in andere Länder/Rechtsordnungen weltweit übertragen. Durch die Nutzung der Dienste stimmen Sie der Übertragung Ihrer Daten außerhalb des EWR zu.



Wenn Sie im EWR ansässig sind, werden Ihre personenbezogenen Daten nur dann an Standorte außerhalb des EWR übertragen, wenn wir davon überzeugt sind, dass ein angemessenes oder vergleichbares Niveau zum Schutz personenbezogener Daten besteht. Wir werden geeignete Schritte unternehmen, um sicherzustellen, dass wir über angemessene vertragliche Vereinbarungen mit unseren Drittparteien verfügen, um zu gewährleisten, dass entsprechende Sicherheitsvorkehrungen getroffen werden, so dass das Risiko einer unrechtmäßigen Nutzung, Änderung, Löschung, eines Verlusts oder Diebstahls Ihrer personenbezogenen Daten minimiert wird und dass diese Drittparteien jederzeit in Übereinstimmung mit den geltenden Gesetzen handeln.

Rechte gemäß kalifornischem Verbraucherschutzgesetz



Wenn Sie die Dienste als Einwohner Kaliforniens nutzen, dann sind Sie möglicherweise nach dem kalifornischen Verbraucherschutzgesetz (California Consumer Privacy Act; „CCPA“) berechtigt, Zugriff auf und Löschung Ihrer Daten zu verlangen.



Um Ihr Recht auf den Zugriff und die Löschung Ihrer Daten geltend zu machen, lesen Sie bitte nachstehend, wie Sie Kontakt zu uns aufnehmen können.

​

Wir verkaufen keine personenbezogenen Daten der Nutzer für die Absichten und Zwecke des CCPA.

​

Nutzer der Dienste, die in Kalifornien ansässig und unter 18 Jahre alt sind, können per E-Mail unter der nachstehend im Abschnitt „Kontakt“ angegebenen Adresse die Löschung ihrer veröffentlichten Inhalte verlangen und erwirken. Diese Anträge müssen alle mit „California Removal Request“ gekennzeichnet sein. Alle Anforderungen müssen eine Beschreibung der Inhalte enthalten, deren Löschung Sie wünschen sowie ausreichende Informationen, mit deren Hilfe wir das Material ausfindig machen können. Wir akzeptieren keine Mitteilungen, die nicht gekennzeichnet sind bzw. nicht ordnungsgemäß übermittelt werden, und wir sind möglicherweise nicht in der Lage zu antworten, wenn Sie nicht ausreichend Informationen zur Verfügung stellen. Bitte beachten Sie, dass Ihre Anforderung nicht sicherstellt, dass das Material vollständig bzw. umfassend gelöscht wird. Von Ihnen veröffentlichtes Material kann beispielsweise von anderen Nutzern oder Dritten wiederveröffentlicht oder erneut gepostet werden.

Aktualisierungen oder Änderungen der Datenschutzrichtlinie

​

Wir können diese Datenschutzrichtlinie nach eigenem Ermessen von Zeit zu Zeit überarbeiten, die auf der Website veröffentlichte Version ist immer aktuell (siehe Angabe zum „Stand“). Wir bitten Sie, diese Datenschutzrichtlinie regelmäßig auf Änderungen zu überprüfen. Bei wesentlichen Änderungen werden wir einen Hinweis dazu auf unserer Website veröffentlichen. Wenn Sie die Dienste nach erfolgter Benachrichtigung über Änderungen auf unsere Website weiter nutzen, gilt dies als Ihre Bestätigung und Zustimmung zu den Änderungen der Datenschutzrichtlinie und Ihr Einverständnis an die Bedingungen dieser Änderungen gebunden zu sein.

Kontakt

​

Wenn Sie allgemeine Fragen zu den Diensten oder den von uns über Sie erfassten Daten und deren Verwendung haben, kontaktieren Sie uns bitte unter:



Name: Arnold Auer

Anschrift: Windhofstraße 49

E-Mail-Adresse: arnold.auer@innovation2go.at



AUSSCHLUSSKLAUSEL

Die hier enthaltenen Informationen ersetzen keine Rechtsberatung und Sie sollten sich nicht allein darauf stützen. Spezifische Anforderungen in Bezug auf Rechtsbegriffe und Richtlinien können sich von Bundesstaat zu Bundesstaat und/oder von Rechtssystem zu Rechtssystem unterscheiden. Wie in unseren Nutzungsbedingungen dargelegt, sind Sie dafür verantwortlich sicherzustellen, dass Ihre Dienste nach dem für Sie maßgeblichen Recht zulässig sind und Sie sich daran halten.

Um sicherzustellen, dass Sie Ihren gesetzlichen Verpflichtungen vollumfänglich entsprechen, empfehlen wir Ihnen ausdrücklich, sich professionell beraten zu lassen, um besser nachvollziehen zu können, welche Anforderungen für Sie speziell gelten.`}
          </p>
        </div>

        <Footer_Under></Footer_Under>

        {/* <footer>
          <div className="container">
            <ul className="flex-row">
              <li>
                <a href="/">Zurück</a>
              </li>
            </ul>
            <ul className="flex-row">
              <li>
                <i className="fa-brands fa-google-play">
                  <FontAwesomeIcon
                    icon={icon({ name: "google-play", style: "brands" })}
                  />
                </i>
              </li>
              <li>
                <i className="fa-brands fa-app-store-ios">
                  <FontAwesomeIcon
                    icon={icon({ name: "app-store-ios", style: "brands" })}
                  />
                </i>
              </li>
            </ul>
            <p>{"© 2022 Innovation2Go"}</p>
          </div>
        </footer> */}
      </body>
    </html>
  );
}
